export function getSelectedNoteId(state) {
    return state.selects.noteId;
}